import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React, { Children, cloneElement } from 'react';
import { SWITCH_SIZES } from '../../constants';
import { StyledSwitchGroup } from './SwitchGroup.styles';
var getChildProps = function getChildProps(_ref) {
  var size = _ref.size,
    fluid = _ref.fluid,
    labelPosition = _ref.labelPosition;
  var props = {
    fluid: fluid,
    labelPosition: labelPosition
  };
  if (typeof size !== 'undefined') {
    props.size = size;
  }
  return props;
};

/**
 * A collection of labeled `Switch` components.
 *
 * @since 6.7.0
 */
export var SwitchGroup = function SwitchGroup(_ref2) {
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledSwitchGroup, props, Children.map(children, function (child) {
    return /*#__PURE__*/cloneElement(child, getChildProps(props));
  }));
};
SwitchGroup.displayName = 'SwitchGroup';
SwitchGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Labeled `Switch` elements in the group */
  children: PropTypes.node.isRequired,
  /**
   * Set `size` for all child `Switch` components.
   * If defined, this will override any `size` value set on the individual components.
   */
  size: PropTypes.oneOf(Object.values(SWITCH_SIZES)),
  /** `SwitchGroup` sets `LabeledControl` to be `fluid` by default */
  fluid: PropTypes.bool,
  /** `SwitchGroup` sets `LabeledControl` to have `left` positioned labels by default */
  labelPosition: PropTypes.oneOf(['left', 'right'])
} : {};
SwitchGroup.defaultProps = {
  size: undefined,
  fluid: true,
  labelPosition: 'left'
};